<mat-toolbar color="primary">
    <button mat-icon-button *ngIf="!hideStartDrawer" (click)="startDrawer.toggle()"><mat-icon>menu</mat-icon></button>
    <div class="header-main-content">
        <span class="env">{{env}}</span>
        <h1 class="header-title">RAR Table Maintenance</h1>
    </div>
    <app-save-button style="margin: 0 2rem;"></app-save-button>
    <button mat-icon-button *ngIf="!hideEndDrawer" (click)="endDrawer.toggle()"><mat-icon>more_vert</mat-icon></button>
</mat-toolbar>
<mat-drawer-container style="flex: 1 1 auto">
    <mat-drawer #startDrawer position="start">
        <app-au-tree-navigation [navigation]="navRoutes" innerStyle="width:350px"></app-au-tree-navigation>
    </mat-drawer>
    <mat-drawer-content>
        <div class="em-u-margin-top-double em-l-container">
            <router-outlet></router-outlet>
        </div>
    </mat-drawer-content>
    <mat-drawer #endDrawer position="end" mode="side" [opened]="true">
        <app-filter #filter></app-filter>
    </mat-drawer>
</mat-drawer-container>